import { PaginationFilterRequest } from "./core.model";
import { UserLookup } from "./user.model";
import { utcToJSDate } from "@/utils/date-time";

export enum MessageContentType {
    Text = 1,
    Image = 2,
    Location = 3
}

export const MessageContentTypeList = [
    { value: MessageContentType.Text, label: "Text" },
    { value: MessageContentType.Image, label: "Image" },
    { value: MessageContentType.Location, label: "Location" },
];

export function messageFromJson(json: any): Message {
    return {
        ...json,
        createdAt: utcToJSDate(json.createdAt)!
    } as Message;
};

/// <summary>Id is a C# long — kept as number, never parsed through anything lossy.</summary>
export interface Message {
    id: number;
    channelId: number;
    contentType: MessageContentType;
    text?: string;
    link?: string;
    lat?: number;
    lng?: number;
    createdAt: Date;
    sender?: UserLookup;
}

export class MessagePaginationFilterRequest extends PaginationFilterRequest {
    beforeMessageId?: number;
    afterMessageId?: number;
}
